(() => {
  const reveal = () => {
    const items = document.querySelectorAll('[data-kos-reveal]:not(.is-visible)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries, currentObserver) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          currentObserver.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    items.forEach((item) => observer.observe(item));
  };

  const launchSanta = (button) => {
    const fallback = button.getAttribute('data-fallback-url') || '/pages/estimate';
    let handled = false;
    const detail = {
      source: 'kingdom-os-homepage',
      button,
      markHandled: () => { handled = true; }
    };

    window.dispatchEvent(new CustomEvent('kingdom:santa:open', { detail }));

    window.setTimeout(() => {
      if (!handled) window.location.assign(fallback);
    }, 120);
  };

  const bind = () => {
    reveal();

    document.querySelectorAll('[data-kos-santa-launch]').forEach((button) => {
      if (button.dataset.kosBound === 'true') return;
      button.dataset.kosBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        launchSanta(button);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }

  document.addEventListener('shopify:section:load', bind);
})();
